module.exports = __webpack_public_path__ + "static/img/TMBcharacterPhotos_0002_lauraMoon.9bb88a8.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/TMBcharacterPhotos_0002_lauraMoon.jpg
// module id = c0wW
// module chunks = 1